var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{row: true}},[_c('div',{staticClass:"question-box"},[_c('Bot',{attrs:{"data":_vm.object.bot}})],1),_c('div',{staticClass:"answer-box"},[_c('Answer',{attrs:{"data":_vm.object.answer}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }